/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { graphql, HttpResponse } from 'msw';

import {
  type DedicatedFreeCreditUsageQuery,
  DedicatedFreeCreditUsageDocument,
  type DedicatedProjectsInHeaderQuery,
  DedicatedProjectsInHeaderDocument,
} from '@fai/friendli-suite/generated/client/graphql';

import { mockUser } from './validation';

const useProjectListQuery = graphql.query<DedicatedProjectsInHeaderQuery>(
  DedicatedProjectsInHeaderDocument,
  () =>
    HttpResponse.json({
      data: {
        dedicatedSubplan: {
          id: mockUser.defaultTeam.id,
          projects: {
            edges: mockUser.defaultTeam.productDedicated.projects.map((project) => ({
              id: '',
              node: project,
            })),
          },
        },
      },
    })
);

const useDedicatedFreeCreditUsageQuery = graphql.query<DedicatedFreeCreditUsageQuery>(
  DedicatedFreeCreditUsageDocument,
  () =>
    HttpResponse.json({
      data: {
        dedicatedSubplan: {
          id: mockUser.defaultTeam.productDedicated.id,
          freeCreditUsage: {
            used: mockUser.defaultTeam.productDedicated.freeCreditUsage.used,
            total: mockUser.defaultTeam.productDedicated.freeCreditUsage.total,
          },
        },
      },
    })
);

const accountHandlers = [useProjectListQuery, useDedicatedFreeCreditUsageQuery];

export default accountHandlers;
